import { render, staticRenderFns } from "./IconFavorites.vue?vue&type=template&id=46bb0e60&scoped=true"
import script from "./IconFavorites.vue?vue&type=script&lang=js"
export * from "./IconFavorites.vue?vue&type=script&lang=js"
import style0 from "./IconFavorites.vue?vue&type=style&index=0&id=46bb0e60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bb0e60",
  null
  
)

export default component.exports